import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { connect, useSelector } from 'react-redux';
import { ErrorSummary, H1, P, scrollToFirstError, useStepperContext, Wrapper } from '@ahmdigital/ui';
import { Formik } from 'formik';
import { isEmpty, pick } from 'lodash/fp';
import React, { useState } from 'react';
import styled from 'styled-components';

import AboutYouForm from './form';
import buildSubmitHandler from '../../../refine-price/utils/build-submit-handler';
import constants from '../../../../ahm-constants';
import CustomerActions from '../../../../actions/customer';
import refinePriceSchema, { RefinePriceSchemaType } from '../../../refine-price/form/schema';
import selectCustomer from '../../../../selectors/select-customer';
import selectCustomerFormInitialValues from '../../../../components/pricing-drawer/selectors/select-customer-form-initial-values';
import type { RefinePriceActions } from '../../../refine-price/types';

const ErrorSummaryWrapper = styled.div`
  text-align: left;
`;

const SCROLL_OFFSET = 100;

const schemaForErrorSummary = {
  age: {
    linkPhrases: ['age'],
  },
  partnerAge: {
    linkPhrases: ['partner’s age'],
  },
};
const errorOrder = ['age', 'partnerAge'];

type Props = {
  actions: RefinePriceActions;
};

const AboutYou = ({ actions }: Props) => {
  const [formikErrors, setFormikErrors] = useState({});
  const [formikTouched, setFormikTouched] = useState({});
  const { goToNextStep } = useStepperContext();
  const initialValues = {
    ...useSelector(selectCustomerFormInitialValues),
    productType: constants.PRODUCT_TYPE.PACKAGE,
  } as RefinePriceSchemaType;
  const customer = useSelector(selectCustomer);
  return (
    <>
      <Wrapper size="small">
        {!isEmpty(formikErrors) && (
          <ErrorSummaryWrapper>
            <ErrorSummary
              schema={schemaForErrorSummary}
              errors={pick(errorOrder, formikErrors)}
              touched={formikTouched}
            />
          </ErrorSummaryWrapper>
        )}
        <H1 looksLike="h2">About you</H1>
        <P variant="marginBottomSpacer10">
          Feeling a bit shy? Tell us a bit about yourself, so we can find you a perfect match.
        </P>
      </Wrapper>
      <div>
        <Formik<RefinePriceSchemaType>
          enableReinitialize
          validationSchema={refinePriceSchema}
          initialValues={initialValues}
          onSubmit={(values: any) => {
            buildSubmitHandler({ actions, customer, formValues: values, initialValues });
            goToNextStep();
          }}
        >
          {({ errors, isSubmitting }) => {
            if (isSubmitting && !isEmpty(errors)) {
              scrollToFirstError({ offset: SCROLL_OFFSET });
            }

            return <AboutYouForm captureFormState={{ setFormikErrors, setFormikTouched }} />;
          }}
        </Formik>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(AboutYou);
